module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAArCAYAAABSFVnaAAAAGUlEQVQYlWN8/vz5fwYGBgYmBigYZdCZAQDShQQKq5v5NgAAAABJRU5ErkJggg=="